import FooterNote from './FooterNote';

export default FooterNote;